<template>
  <div class="product-card">
    <GFMP
      :wrapper-styles="{ width: '76px', aspectRatio: '1/1' }"
      :styles="{ ...fmpStyles.rounded, height: '100%', width: '100%' }"
    />
    <div class="product-card-content">
      <GFMP v-for="_i in 2" :key="_i" :styles="{ ...fmpStyles.rounded, width: getRandomPercentage(40) }" />
      <div class="product-card-content-rating">
        <GFMP v-for="_i in 5" :key="_i" :styles="fmpStyles.circle" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-inline-loader',
  data() {
    return {
      fmpStyles: {
        rounded: {
          borderRadius: '8px',
          height: '12px',
        },
        circle: {
          borderRadius: '50%',
          height: '16px',
          minWidth: '16px',
        },
      },
    };
  },
  methods: {
    getRandomPercentage(min = 30, max = 100) {
      return `${min + Math.random() * (max - min)}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';

.product {
  &-card {
    display: flex;
    gap: 16px;
    width: 100%;
    padding: 16px;
    background-color: white;
    border-radius: 4px;

    &-content {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      gap: 8px;

      &-rating {
        display: flex;
        gap: 8px;
      }
    }
  }
}
</style>
